import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'bytesToKB'})
export class BytesToKilobytesPipe implements PipeTransform {
  transform(value: number): any {
    return (value / 1024).toFixed(2);
  }
}
